import { registerApplication, start } from "single-spa";
import store from "./common/store";
import i18n, { configurei18n } from "./common/i18n/i18n";
import deepFreeze from "./common/js/utils/deepFreeze";
import isInsideIframe from "./common/js/utils/isInsideIframe";
import { CONFIG_URL, SHARED_CONFIG } from "./common/constants";
import { Request } from "./common/react/api/user/User.api";
import { deleteUser } from "./common/store/user";

import "./common/theme/theme.scss";

const { cookieset } = Object.fromEntries(new URLSearchParams(location.search));
const shouldShow = (location) => {
  return (
    true &&
    !location.pathname.startsWith("/password-reset") &&
    !location.pathname.startsWith("/seamless") &&
    !location.pathname.startsWith("/user/deposit/response") &&
    !location.pathname.startsWith("/layout_mobile")
  );
};

const shouldShowCookiesApp = (location) => {

  const excludedPaths = [
    "/password-reset",
    "/seamless",
    "/user/deposit/response",
    "/layout_mobile"
  ];

  const isPathExcluded = excludedPaths.some(path => location.pathname.startsWith(path));

  // Se il percorso inizia con uno dei path esclusi, ritorna false
  if (isPathExcluded) {
    return false;
  }

  return true
};

const iframeForMsite = (location) => {
  return (
    true &&
    (location.pathname.startsWith("/seamless") ||
      location.pathname.startsWith("/layout_mobile") ||
      location.pathname.startsWith("/password-reset"))
  );
};
const timeStamp = Date.now();
const fetchConfig = () => fetch(CONFIG_URL + "?ts=" + timeStamp).then((res) => res.json());
const fetchSharedConfig = () => fetch(SHARED_CONFIG + "?ts=" + timeStamp).then((res) => res.json());

export const configureSingleSPA = async () => {
  const props = {};
  if (!isInsideIframe() || iframeForMsite(window.location)) {
    // Make sure settings is not mutated
    const config = deepFreeze(await fetchConfig());
    const sharedConfig = deepFreeze(await fetchSharedConfig());
    configurei18n(config);
    Object.assign(props, { config, i18n, store, sharedConfig});
    window.childFrameProps = props;
  } else {
    Object.assign(props, window.parent.childFrameProps);
  }

  registerApplication("header", () => import("./header/Header.app.js"), shouldShow, props);

  registerApplication(
    "main",
    () => import("./main/Main.app.js"),
    () => true,
    props
  );

  registerApplication(
    "private",
    () => import("./private/Private.app.js"),
    (location) => location.pathname.startsWith("/user") || location.pathname.startsWith("/seamless"),
    props
  );

  registerApplication(
    "sport",
    () => import("./sport/Sport.app.js"),
    (location) => location.pathname.startsWith("/sport"),
    props
  );

  if(props?.config?.country_code !== "at"){
      registerApplication(
      "live",
      () => import("./live/Live.app.js"),
      (location) => location.pathname.startsWith("/live"),
      props
    );
  }

  registerApplication("footer", () => import("./footer/Footer.app.js"), shouldShow, props);

  registerApplication("cookies", () => import("./cookies/Cookies.app.js"), shouldShowCookiesApp, props);

  start();
};

function clearStorage() {
  let session = !!sessionStorage ? sessionStorage.getItem("ref") : null;
  const initialUser = !!localStorage && localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
  if (session == null) {
    if (initialUser) {
      if (!!initialUser.login_data === false) {
        store.dispatch(deleteUser());
      } else {
        const values = { card: initialUser.carta, token: initialUser.login_data.token, language: i18n.language };
        Request.checkSession(values)
          .then((response) => {
            if (response.error?.code === "-607") {
              store.dispatch(deleteUser());
            }
          })
          .catch(() => {
            store.dispatch(deleteUser());
          });
      }
    }
  }
  configureSingleSPA();
  if (!!sessionStorage) sessionStorage.setItem("ref", 1);
}
window.addEventListener("load", clearStorage);
